export function validateQtAndDiscount(data) {
    const value = Number(
        String(data.qt_value || 0).replace(/,/g, '')
    );
    const discount = Number(
        String(data.discount || 0).replace(/,/g, '')
    );
    const hasValue =
        data.qt_value !== undefined &&
        data.qt_value !== '' &&
        data.discount !== undefined &&
        data.discount !== '';
    return {
        value,
        discount,
        isInvalid: hasValue && discount >= value
    };
}

export function currencyConfig(options = {}) {
  return {
    distractionFree: false,
    currency: null,
    allowNegative: false,
    precision: 2,
    ...options,
  };
}